export function assertValue(value: unknown, message?: string): asserts value {
  if (value === null || value === undefined) {
    const errorMessage = message
      ? `assertValue function error: ${message}`
      : 'assertValue function error';
    // TODO: consider moving logException to utils lib and use it instead captureException
    throw new Error(errorMessage);
  }
}

export function isDefined<T>(value: T | undefined | null): value is T {
  return value !== undefined && value !== null;
}

export function allElementsAreDefined<T>(
  array: (T | undefined | null)[]
): array is T[] {
  return array.every(isDefined);
}

export function exhaustiveGuard(_: never, errorMessage: string): never {
  throw new Error(errorMessage);
}
